export function makeIdentifierPrefix(blockId: string) {
  return `evergreen:${blockId}:`
}
